class MessagingSocketService {
  constructor() {
    if (new.target === MessagingSocketService) {
      throw new Error("Cannot instantiate an abstract class.");
    }
    if (this.connect === MessagingSocketService.prototype.connect) {
      throw new Error(
        "Class extending MessagingSocketService must override 'connect({ userId, chatChannelId, avatarId, aiStatusCallback, aiResponseCallback, errorCallback, messageStatusCallback })'."
      );
    }
    if (this.sendMessage === MessagingSocketService.prototype.sendMessage) {
      throw new Error("Class extending MessagingSocketService must override 'sendMessage({ message, uniqueKey })'.");
    }
    if (this.disconnect === MessagingSocketService.prototype.disconnect) {
      throw new Error("Class extending MessagingSocketService must override 'disconnect()'.");
    }
  }

  connect({ userId, chatChannelId, avatarId, aiStatusCallback, aiResponseCallback, errorCallback, messageStatusCallback }) {
    throw new Error(
      "Method 'connect({ userId, chatChannelId, avatarId, aiStatusCallback, aiResponseCallback, errorCallback, messageStatusCallback })' must be implemented."
    );
  }

  sendMessage({ message, uniqueKey }) {
    throw new Error("Method 'sendMessage({ message, uniqueKey })' must be implemented.");
  }

  disconnect() {
    throw new Error("Method 'disconnect()' must be implemented.");
  }
}

export default MessagingSocketService;
